class RegimeTributarioIcmsController extends AbstractController
  @$inject = [ '$injector', '$scope', 'pathService', 'estadoService', 'regimeTributarioIcmsService' ]

  constructor: ($injector, @scope, pathService, @estadoService, @regimeTributarioService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/regime-tributario/"
    @loadingTracker = @promiseTracker()
    @modalRegimeTributario = @openPopup(@url + "modal.html", 'regimeTributarioIcmsModalController as ctrl')

    @filtro =
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfEstado = []

    @loadingTracker.addPromise @estadoService.getList((data) =>
      @listOfEstado = data
    )

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @regimeTributarioService.getList(filtro, (result) =>
      if result.success
        @listOfRegimeTributario = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de Regime Tributário.', 'Erro!', false)
    )


  add: ->
    @modalRegimeTributario({
      regimeTributario: => {
      estado: @filtro.estado
      }
      listOfEstado: =>  @listOfEstado
    }, (result) =>
      @loadData())

  edit: (regimeTributario) ->
    @modalRegimeTributario({
      regimeTributario: => angular.copy regimeTributario
      listOfEstado: =>  @listOfEstado
    }, (result) =>
      @loadData())

  remover: (regimeTributario)->
    Confirm.warning('Atenção', "Deseja realmente remover o regime tributário ##{regimeTributario.id} - #{regimeTributario.nome}?", {
      Sim: =>
        @regimeTributarioService.delete(regimeTributario.id, (result)=>
          if(result.success)
            Alert.success("O regime tributário ##{regimeTributario.id} - #{regimeTributario.nome} foi removido!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover o regime tributário ##{regimeTributario.id} - #{regimeTributario.nome}.")
        )
      Não: ''
    })

angular.module('eficienciaFiscalModule').controller('regimeTributarioIcmsController', RegimeTributarioIcmsController)

class RegimeTributarioIcmsModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'regimeTributarioIcmsService', 'regimeTributario', 'listOfEstado' ]

  constructor: ($injector, @modalInstance, @regimeTributarioService, @regimeTributario, @listOfEstado) ->
    super($injector)

    @listOfTabela = [
      {id: 'isencao', nome: 'Isenção'}
      {id: 'reducao_base_calculo', nome: 'Redução da Base de Cálculo'}
      {id: 'substituicao_tributaria', nome: 'Substituição Tributária'}
    ]

    @listOfTipoIsencao = [
      {id: 'isencao', nome: 'Isenção'}
      {id: 'imunidade', nome: 'Imunidade'}
      {id: 'nao_incidencia', nome: 'Não incidência'}
    ]

    @regimeTributario.calculaAt = false unless @regimeTributario.calculaAt
    @regimeTributario.calculaDa = false unless @regimeTributario.calculaDa
    @regimeTributario.retemCredito = false unless @regimeTributario.retemCredito
    @submitTracker = @promiseTracker()

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @regimeTributarioService.save(@regimeTributario, (data) =>
        Alert.success("Regime tributário Nº  <strong>#{data.id}</strong> #{if @regimeTributario.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )


angular.module('eficienciaFiscalModule').controller('regimeTributarioIcmsModalController', RegimeTributarioIcmsModalController)